<template>
  <div class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <CRow class="justify-content-center">
        <CCol md="6">
          <CCard class="mb-0 p-0">
            <CCol sm="12" lg="12">
              <div class="text-center">
                <img
                  src="../assets/img/rate.png"
                  style="max-width: 100%; height: 200px"
                  class="text-center"
                />
              </div>
            </CCol>
          
            <div class="text-center text-title text-bold">
              <h2 class="display-5">Write your Feedback</h2>
              <br />
              <span class="m-3">1 - Unacceptable</span>  <span class="m-3">2 - Below Average </span><span class="m-3"> 3 -Average </span> <span class="m-3">4 - Above Average</span><span class="m-3"> 5
              - Outstanding</span>

              <CInput
                type="text"
                class="mt-3 ml-3 mr-3"
                v-model="parents.userName"
                placeholder="Enter your Name"
                disabled
              />
              <v-select
                class="mt-3 ml-3 mr-3 mb-3"
                v-model="SelectedClass"
                :options="classes"
                label="SubjectName"
                placeholder="--Please Select Class--"
              ></v-select>
              <!-- <CCard
                class="mt-3 ml-3 mr-3"
                v-for="(item, index) in quest"
                v-bind:key="index"
              >
                <span class="mt-3 ml-3 mr-3">
                  <strong>{{ item.Question }}</strong>
                </span>
                <span class="mt-3 mb-3">
                  <input type="radio" :value="item.Choice1" v-model="answer[index]" />1
                  <input type="radio" :value="item.Choice2" v-model="answer[index]" />2
                  <input type="radio" :value="item.Choice3" v-model="answer[index]" />3
                  <input type="radio" :value="item.Choice4" v-model="answer[index]" />4
                  <input type="radio" :value="item.Choice5" v-model="answer[index]" />5
                </span>
              </CCard> -->

              <CCard v-for="(question, index) in questions" v-bind:key="index">
                <span class="mt-3 ml-3 mr-3">
                  <strong>{{ question.Question }} </strong></span
                >

                <span class="columns">
                  <span
                    class="column"
                    v-for="(answer, indexanswer) in question.answers"
                    v-bind:key="indexanswer"
                  >
                    <input
                      :id="'radio-' + answer.Id"
                      :value="answer.points"
                      class="radio-custom"
                      v-model="chosen[index]"
                      type="radio"
                    />
                    <label
                      :for="'radio-' + answer.Id"
                      class="radio-custom-label m-3"
                      ><br />{{ answer.description }}</label
                    >
                  </span>
                </span>
              </CCard>
              <CTextarea
                class="mt-3 ml-3 mr-3"
                v-model="Comment"
                placeholder="Do you have any suggestions to improve the tutoring service at PICKIDDO?"
              ></CTextarea>

               <CRow class="mt-2">
                <CCol sm="12">
                 <div v-if="this.SuccessMessage===true" class="ml-4 mr-4">
                          <CAlert show color="success"
                            >You have successfully send the feedback</CAlert
                          >
                        </div>
                </CCol>
              </CRow>
              <CRow class="mt-3 ml-3 mr-3 mb-5">
                <CButton
                  type="button"
                  class="btn btn-success p-3"
                  block
                  @click="SubmitAnswer(index)"
                  >Submit Feedback</CButton
                >

                <br /><br /><br />
              </CRow>
             
            </div>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

export default {
  name: "Collapses",
  data() {
    return {
      SelectedClass: "",
      classes: [],

      parents: {},
      quest: [],
      Comment: "",
      RateId: "",
      StudentId: "",
      QuestionId: "",
      ClassId: "",
      rate: "",

      rates: [],
      answer: "",

      SuccessMessage: false,

      chosen: [],
      questions: [
        {
          Id: 1,
          Question: "The tutor provides encouragement when I am stuck",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 2,
          Question: "The tutor is friendly and eager to help",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 3,
          Question:
            "The tutor uses good examples that help me understand the problem",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 4,
          Question:
            "The tutor tries to explain problems in a clear, concise manner",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 5,
          Question: "The tutor helps me solve the problems myself",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 6,
          Question: "The tutor helps me to understand the general concepts",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 7,
          Question: "The tutor is patient and waits for me to give answers",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 8,
          Question: "The tutor is familiar with the textbook used",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 9,
          Question: "The tutor has excellent communication skills",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 10,
          Question: "The tutor behaves and dresses in a professional manner",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 11,
          Question:
            "After my tutoring session, I feel more confident in approaching the assignment",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
        {
          Id: 12,
          Question: "Overall, my experience with the tutoring session was",
          answers: [
            { Id: 1, points: "1", description: "1" },
            { Id: 2, points: "2", description: "2" },
            { Id: 3, points: "3", description: "3" },
            { Id: 4, points: "4", description: "4" },
            { Id: 5, points: "5", description: "5" },
          ],
        },
      ],
    };
  },
  async mounted() {
    await this.GetStudentSubjectList();
    await this.GetParentDetail();
    await this.GetListQuestion();
    await this.GetRate();
  },
  methods: {
    async GetStudentSubjectList() {
      this.$API
        .get(this.$StudentSubjectList + "?id=" + this.$route.query.userID, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.classes = response.data;
          }
        });
    },
    async GetParentDetail() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.$route.query.userID, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.parents = response.data;
          }
        });
    },
    async GetListQuestion() {
      this.$API
        .get(this.$ListQuestionFeedback, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.quest = response.data;
          }
        });
    },
    async GetRate() {
      this.$API
        .get(this.$GetRates, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.rates = response.data;
          }
        });
    },

    async SubmitAnswer(index) {
      const formData = new FormData();

      var combinedrates = [];
      for (let i in this.chosen) {
        let item = this.chosen[i];

        console.log(i + "testing");
        console.log(item + "console");

        if (i == 0) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 1,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 1) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 2,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 2) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 3,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 3) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 4,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 4) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 5,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 5) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 6,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 6) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 7,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 7) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 8,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 8) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 9,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 9) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 10,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 10) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 11,
            RateId: item,
            Comment: this.Comment,
          });
        } else if (i == 11) {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 12,
            RateId: item,
            Comment: this.Comment,
          });
        } else {
          combinedrates.push({
            StudentId: this.$route.query.userID,
            ClassId: this.SelectedClass.SubjectID,
            QuestionId: 0,
            RateId: item,
            Comment: this.Comment,
          });
        }
      }

      let feedData = JSON.stringify(combinedrates);

      formData.append("ansJson", feedData);

      return this.$API
        .post(this.$SubmitFeedback, formData, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.SuccessMessage = true;
            this.GoToRefresh();
          }
        })
        .catch((error) => {
          if (error.response) {
            this.Busy = false;
            this.Error = true;
          }
        });
    },
  },
};
</script>

<style>

#fb-root{
  display:none;
}
</style>